import { render, staticRenderFns } from "./YoutubeEmbedLite.vue?vue&type=template&id=fc1ca554&"
import script from "./YoutubeEmbedLite.vue?vue&type=script&lang=js&"
export * from "./YoutubeEmbedLite.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeEmbedLite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports